(function () {
  'use strict';

  function store(key, value) {
    try {
      if (value === undefined) return window.localStorage.getItem(key);
      window.localStorage.setItem(key, value);
    } catch (e) { return null; }
    return null;
  }

  // ---------- Light / dark mode ----------
  var rootEl = document.documentElement;
  function syncThemeButtons() {
    var dark = rootEl.getAttribute('data-theme') === 'dark';
    document.querySelectorAll('[data-theme-toggle]').forEach(function (b) {
      b.setAttribute('aria-label', dark ? 'Switch to light mode' : 'Switch to dark mode');
      b.setAttribute('aria-pressed', dark ? 'true' : 'false');
    });
  }
  document.querySelectorAll('[data-theme-toggle]').forEach(function (b) {
    b.addEventListener('click', function () {
      var next = rootEl.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
      rootEl.setAttribute('data-theme', next);
      store('yarime-theme', next);
      syncThemeButtons();
    });
  });
  if (window.matchMedia) {
    var mq = window.matchMedia('(prefers-color-scheme: dark)');
    var follow = function (e) {
      if (store('yarime-theme')) return; // the visitor chose; keep it
      rootEl.setAttribute('data-theme', e.matches ? 'dark' : 'light');
      syncThemeButtons();
    };
    if (mq.addEventListener) mq.addEventListener('change', follow); else if (mq.addListener) mq.addListener(follow);
  }
  syncThemeButtons();

  // ---------- Bag count: keep the number in its own badge ----------
  document.querySelectorAll('.bag-btn').forEach(function (btn) {
    var count = btn.querySelector('.bag-btn__count');
    if (!count || !('MutationObserver' in window)) return;
    new MutationObserver(function () {
      btn.childNodes.forEach(function (n) {
        if (n.nodeType !== 3) return;
        var m = n.textContent.match(/(\d+)\s*$/);
        if (m) { count.textContent = m[1]; n.textContent = ' '; }
      });
    }).observe(btn, { childList: true, characterData: true, subtree: true });
  });

  // ---------- Pop-up: never move the page when it opens or closes ----------
  document.querySelectorAll('[data-popup]').forEach(function (popup) {
    var savedY = null;
    if ('MutationObserver' in window) {
      new MutationObserver(function () {
        if (!popup.hidden) { if (savedY === null) savedY = window.scrollY; }
        else if (savedY !== null) {
          var y = savedY; savedY = null;
          window.scrollTo(0, y);
          requestAnimationFrame(function () { window.scrollTo(0, y); });
          setTimeout(function () { window.scrollTo(0, y); }, 60);
        }
      }).observe(popup, { attributes: true, attributeFilter: ['hidden'] });
    }
    var origFocus = HTMLElement.prototype.focus;
    popup.querySelectorAll('[data-popup-close], input, button').forEach(function (el) {
      el.focus = function (opts) { origFocus.call(this, Object.assign({ preventScroll: true }, opts || {})); };
    });
  });

  // ---------- Colour filter on shop pages ----------
  var colourNav = document.querySelector('[data-colour-filter]');
  if (colourNav) {
    var params = new URLSearchParams(window.location.search);
    var colour = (params.get('colour') || '').toLowerCase();
    var withColour = function (href) {
      var u = new URL(href, window.location.href);
      if (colour) u.searchParams.set('colour', colour); else u.searchParams.delete('colour');
      return u.pathname + (u.search || '');
    };
    // Price links keep the chosen colour
    document.querySelectorAll('[data-keep-colour]').forEach(function (a) { a.setAttribute('href', withColour(a.getAttribute('href'))); });
    // Colour links keep the chosen price range and sort
    document.querySelectorAll('[data-colour-pill]').forEach(function (a) {
      var c = a.getAttribute('data-colour-pill');
      var u = new URL(window.location.href);
      if (c) u.searchParams.set('colour', c); else u.searchParams.delete('colour');
      u.searchParams.delete('page');
      a.setAttribute('href', u.pathname + (u.search || ''));
      var on = c === colour;
      a.classList.toggle('is-active', on);
      if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
    });
    var cpill = colour && document.querySelector('[data-colour-pill="' + colour + '"]');
    var clabel = document.querySelector('[data-colour-label]');
    if (cpill && clabel) clabel.textContent = cpill.getAttribute('data-colour-name') || colour;
    var badge = document.querySelector('[data-filters-count]');
    if (badge && cpill) { badge.textContent = (parseInt(badge.textContent, 10) || 0) + 1; badge.hidden = false; }
    if (colour) {
      var shown = 0;
      document.querySelectorAll('.product-grid .card').forEach(function (card) {
        var match = (card.getAttribute('data-colours') || '').indexOf(' ' + colour + ' ') > -1;
        card.hidden = !match;
        if (match) shown++;
      });
      var countEl = document.querySelector('[data-shown-count]');
      if (countEl) countEl.textContent = shown + ' ' + (shown === 1 ? countEl.getAttribute('data-word-one') : countEl.getAttribute('data-word-many'));
      var empty = document.querySelector('[data-colour-empty]');
      if (empty) empty.hidden = shown > 0;
    }
  }

  // ---------- Filter panel open / close ----------
  var fPanel = document.querySelector('[data-filters-panel]');
  if (fPanel) {
    var fMain = document.querySelector('.filters-toggle[data-filters-toggle]');
    var setOpen = function (open) {
      fPanel.hidden = !open;
      if (fMain) fMain.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    document.querySelectorAll('[data-filters-toggle]').forEach(function (b) {
      b.addEventListener('click', function () { setOpen(fPanel.hidden); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !fPanel.hidden) { setOpen(false); if (fMain) fMain.focus(); } });
    // Wide screens: show every group open side by side
    if (window.matchMedia && window.matchMedia('(min-width: 900px)').matches) {
      fPanel.querySelectorAll('details.fgroup').forEach(function (d) { d.open = true; });
    }
  }

  // ---------- Same-day delivery countdown (Dubai time, 8pm cut-off) ----------
  var samedays = document.querySelectorAll('[data-sameday]');
  if (samedays.length && window.Intl) {
    var CUTOFF = 20 * 60; // 8pm
    var dubaiMinutes = function () {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Dubai', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date());
      var h = 0, m = 0;
      parts.forEach(function (p) { if (p.type === 'hour') h = parseInt(p.value, 10) % 24; if (p.type === 'minute') m = parseInt(p.value, 10); });
      return h * 60 + m;
    };
    var tick = function () {
      var left = CUTOFF - dubaiMinutes();
      samedays.forEach(function (el) {
        var short = el.hasAttribute('data-sameday-short');
        var txt = el.querySelector('[data-sameday-text]');
        if (!txt) return;
        if (left > 0) {
          var h = Math.floor(left / 60), m = left % 60;
          var time = (h ? h + 'h ' : '') + m + 'm';
          txt.innerHTML = 'Order within <strong>' + time + '</strong> for same-day delivery' + (short ? '' : ' in Dubai');
        } else {
          txt.innerHTML = 'Order now for delivery <strong>tomorrow</strong>' + (short ? '' : ' in Dubai');
        }
        el.hidden = false;
        var stat = el.parentNode && el.parentNode.querySelector('[data-ann-static]');
        if (stat) stat.hidden = true;
      });
    };
    tick();
    setInterval(tick, 30000);
  }

  // ---------- Phone: slim "Add to bag" bar on product pages ----------
  var form = document.querySelector('[data-product-form]');
  var mainBtn = form && form.querySelector('[data-add-button]');
  var titleEl = document.querySelector('.product__title');
  var priceEl = document.querySelector('[data-product-price]');
  if (form && mainBtn && titleEl && 'IntersectionObserver' in window) {
    var bar = document.createElement('div');
    bar.className = 'sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="sticky-atc__info"><span class="sticky-atc__title"></span><span class="sticky-atc__price"></span></div>' +
      '<button type="button" class="btn btn--solid sticky-atc__btn" tabindex="-1">Add to bag</button>';
    bar.querySelector('.sticky-atc__title').textContent = titleEl.textContent.trim();
    var barPrice = bar.querySelector('.sticky-atc__price');
    var barBtn = bar.querySelector('.sticky-atc__btn');
    var syncBar = function () {
      if (priceEl) {
        var clone = priceEl.cloneNode(true);
        clone.querySelectorAll('s').forEach(function (s) { s.remove(); });
        barPrice.innerHTML = clone.innerHTML;
      }
      barBtn.disabled = mainBtn.disabled;
      var label = mainBtn.querySelector('[data-add-text]');
      barBtn.textContent = label ? label.textContent : 'Add to bag';
    };
    syncBar();
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(syncBar);
      if (priceEl) mo.observe(priceEl, { childList: true, subtree: true, characterData: true });
      mo.observe(mainBtn, { attributes: true, childList: true, subtree: true, characterData: true });
    }
    barBtn.addEventListener('click', function () {
      if (form.requestSubmit) form.requestSubmit(mainBtn); else mainBtn.click();
    });
    document.body.appendChild(bar);
    new IntersectionObserver(function (entries) {
      var show = !entries[0].isIntersecting;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      rootEl.classList.toggle('has-sticky-atc', show);
    }).observe(mainBtn);
  }
})();
